import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from "react";

import "./teacherList.css";
import SideBar from "../../commanComponents/sidebar/sidebar";
import { titleCase } from '../../../utils/utils';
import { clearData } from '../../../utils/localStorage';
import AdvancedTable from "../../commanComponents/advancedTable/advancedTable";
import TopNavigation from "../../commanComponents/topNavigation/topNavigation";
import { ROUTES, sidebarNavItems } from '../../../constant';
import { getSchoolTeacherListService, getSessionListService } from "../../../modules/services";
import PrimaryButton from '../../commanComponents/primaryButton/primaryButton';


const TeacherList = () => { 
    const [dataMeta, setDataMeta] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [pagNo, setPageNo] = useState(1);
    const [sessionData, setSessionData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();


    const renderDropdownListData = (listData, label, value, id) => {
        return(listData.map(data => ({label: data[label], value: data[value], id: data[id]})))
    }

    const getTeacherListData = (pageNo, sessionId, fromFilter=false) => {
        setIsLoading(true);
        (async () => {
            const responseData = await getSchoolTeacherListService({
                page: pageNo,
                pagination: true,
                session_id: sessionId
            });
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                if (fromFilter) {
                    setDataList(responseData.data[0].results);
                 }
                else {
                    setDataList([...dataList, ...responseData.data[0].results]);
                }

                setDataMeta(responseData.data[0].links);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
                toast.error(responseData.data.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            else {
                clearData();
                toast.error(responseData.data.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                });
                navigate(ROUTES.LOGIN);
            }
        })();
    };

    const getSessionData = () => { 
        setIsLoading(true);
        (async () => {
            const responseData = await getSessionListService({pagination: false});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                const sessionList = renderDropdownListData(responseData.data, "session_name", "id", "id");
                setSessionData(sessionList);
                getTeacherListData(pagNo, sessionList[0]?.value);

                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    useEffect(() => {
        getSessionData();
    }, []);

    const handleLoadMore = () => {
        if (dataMeta.next) {
            setIsLoading(true);
            const _pageNo = dataMeta.current + 1;
            setPageNo(_pageNo);
            getTeacherListData(_pageNo);
        }
    }

    const onClickDetail = () => {

    }

    const handleAddTeacherButton = () => {
        navigate(ROUTES.ADMIN_ADD_TEACHERS);
    }
    
    const tableColumns = [
        {
            accessor: prop => prop.first_name + " " + prop.last_name,
            Header: 'Full Name',
            onClick: true,
            minWidth: 170
        },
        {
            accessor: 'email',
            Header: 'Email',
            minWidth: 170,
        },
        {
            accessor: "gender",
            Header: "Gender",
            minWidth: 170,
        },
        {
            accessor: prop => titleCase(prop.status),
            Header: 'Status',
            minWidth: 170,
        },
    ];


    return (
        <div className='student-list-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.adminTeachers} />
            <div className='student-list-side-container'>
                <TopNavigation activeItem={sidebarNavItems.adminTeachers} />
                
                <div className='row student-list-filter-container'>
                <div className='student-list-filter-inner-div'>
                        <PrimaryButton
                            text="Add Teacher"
                            isLoading={isLoading}
                            onClick={handleAddTeacherButton}
                        />
                    </div>
                </div>
                
                <div className='student-list-main-container'>
                    <AdvancedTable columns={tableColumns} data={[...dataList]} isLoading={isLoading} handleLoadMore={handleLoadMore} onClickDetails={onClickDetail} rowCount={dataMeta.count} />
                </div>
            </div>
        </div>
    );
}


export default TeacherList;
